<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                        v-model="search.rental_fee"
                        class="form-control select"
                        placeholder="ห้องพัก"
                        :options="OptionRentalFee"
                        label="rental_name"
                        :show-labels="false"
                        track-by="id">
                    </multiselect>
                    &nbsp
                    <multiselect
                        class="form-control select"
                        v-model="search.employee"
                        :options="employeeOption"
                        :customLabel="employeeLabel"
                        :show-labels="false"
                        select-label=""
                        selectedLabel=""
                        deselectLabel=""
                        multiple
                        placeholder="ค้นหาพนักงาน"
                        track-by="id">
                    </multiselect>
                    &nbsp
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchRentalFee"
                            type="button">
                        <icon name="search">
                        </icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <button class="btn btn-warning my-2 my-sm-0"
                            @click="createRentalFee"
                            type="button">
                        <icon name="plus"></icon>
                        เพิ่มห้องพัก
                    </button>
                    &nbsp
                    <button class="btn btn-secondary my-2 my-sm-0"
                            @click="reportRentalFee"
                            type="button">
                        <icon name="print"></icon>
                        รายงานห้องพัก
                    </button>
                    &nbsp
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">ห้องพัก</th>
                    <th scope="col">รหัส</th>
                    <th scope="col">พนักงาน</th>
                    <th scope="col">ราคาค่าไฟ/หน่วย</th>
                    <th scope="col">ราคาค่าน้ำ/คน</th>
                    <th scope="col">จำนวนผู้พักอาศัย</th>
                    <th scope="col">ค่าห้องพัก</th>
                    <th scope="col">ดูข้อมูล</th>
                    <th scope="col">แก้ไข/ยกเลิก</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in rentalList">
                    <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                    <td>{{ data.rental_name }}</td>
                    <td>
                        <template v-if="data.employee_no">
                            <span v-for="x in data.employee_no.split(',')">
                                {{ x }} <br>
                            </span>
                        </template>

                    </td>
                    <td>
                        <template v-if="data.employee_name">
                            <span v-for="x in data.employee_name.split(',')">
                                {{ x }} <br>
                            </span>
                        </template>
                    </td>
                    <td>{{ data.bill | currency }}</td>
                    <td>{{ data.water_price | currency }}</td>
                    <td>{{ data.count }}</td>
                    <td>{{ data.rent_price | currency }}</td>
                    <td>
                        <button class="btn btn-primary"
                                @click="goToElectricityBill(data.id)">
                            ดูข้อมูล
                        </button>
                    </td>
                    <td>
                        <a @click="editRentalFee(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp&nbsp
                        <a @click="showModalDelete(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <!--b-modal-->
        <b-modal hide-header hide-footer ref="rental_fee">
            <rental-fee-modal @submit="saveRentalFee" :optionEmployee="employeeAll">
            </rental-fee-modal>
        </b-modal>

        <!--b-modal-->
        <b-modal hide-header hide-footer ref="rental_fee_excel">
            <div style="text-align: center;">
                <h3>รายงานค่าเช่าบ้าน</h3>
                <br/>
                <div class="row">
                    <div class="col-3">
                        <span>ห้องพัก</span>
                    </div>
                    <div class="col-8">
                        <multiselect
                            v-model="search.rental_fee"
                            class="select"
                            placeholder="ห้องพัก"
                            :options="OptionRentalFee"
                            multiple
                            :close-on-select='false'
                            label="rental_name"
                            :show-labels="false"
                            track-by="id">
                        </multiselect>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-3">
                        <span>เดือนที่</span>
                    </div>
                    <div class="col-8">
                        <date-picker
                            v-model="search.date"
                            type="month"
                            :format="changeFormat"
                            :lang="lang"
                            range
                            confirm
                            placeholder="เดือนที่รายงาน">
                        </date-picker>
                    </div>
                </div>
                <br/>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="getExcel">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="this.hideRentalFeeExcel">
                    ยกเลิก
                </button>
            </div>
        </b-modal>

        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteRentalFee">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideModalDelete">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <div v-if="rentalList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getRentalList">
            </vue-pagination>
        </div>
        <br>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status_loading"></loading>
        </b-modal>
        <!--        <pre class="alert-success">{{search}}</pre>-->
    </div>
</template>

<script>
import RentalFeeModal from "./Modal/RentalFeeModal";
import {mapState} from "vuex"
import VuePagination from "../../../Pagination";
import Multiselect from "vue-multiselect";
import Loading from "../../../Utility/Loading";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import {domain} from "../../../../util/Constants";

export default {
    components: {
        Loading,
        RentalFeeModal,
        VuePagination,
        Multiselect,
        DatePicker
    },
    name: "rental-fee-list",
    created() {
        this.$store.dispatch("RentalFee/setRentalFee", this.search.before_page);
        this.$store.dispatch("RentalFee/getRentalFeeAll");
        this.$store.dispatch("RentalFee/clearFormData");
        this.$store.dispatch("RentalFee/clearSearch");
        this.$store.dispatch("Employee/getEmployeeAll").then(res => {
            this.employeeOption = res;
            this.employeeAll = res.filter(data => !data.rental_fee_id);
        });
    },
    computed: {
        ...mapState({
            rentalList: state => {
                return state.RentalFee.rentalFeeList;
            },
            OptionRentalFee: state => {
                return state.RentalFee.rentalFeeListAll;
            },
            dataPaginate: state => {
                return state.RentalFee.dataPaginate;
            },
            search: state => {
                return state.RentalFee.search;
            },
        })
    },
    data() {
        return {
            msg: '',
            status_loading: '',
            employeeAll: [],
            id: "",
            event_submit: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            employeeOption: [],
        };
    },
    methods: {
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}`
        },
        getRentalList() {
            const page = this.dataPaginate.current_page;
            this.search.before_page = page;
            this.msg = 'รอสักครู่';
            this.status_loading = 1;
            this.showLoadingModal();
            //paginate search
            if (this.event_submit) {
                if (this.search.rental_fee) {
                    this.search.rental_fee_id = this.search.rental_fee.id
                } else {
                    this.search.rental_fee_id = ""
                }
                let data = {
                    page: page,
                    rental_fee_id: this.search.rental_fee_id
                };
                this.$store.dispatch('RentalFee/search', data).then(() => {
                    this.hideLoadingModal();
                })
            }
            //paginate get data
            else {
                this.$store.dispatch('RentalFee/setRentalFee', page).then(() => {
                    this.hideLoadingModal();
                })
            }

        },
        searchRentalFee() {
            this.event_submit = true;
            this.search.before_page = this.dataPaginate.current_page;
            //change date format

            if (this.search.rental_fee) {
                this.search.rental_fee_id = this.search.rental_fee.id
            } else {
                this.search.rental_fee_id = ""
            }
            let employee_id = '';
            if (this.search.employee.length > 0) {
                this.search.employee.forEach((a, i) => {
                    this.search.employee.length == i + 1 ? employee_id = employee_id + a.id : employee_id = employee_id + a.id + ',';
                })
            }
            this.search.employee_id = employee_id;
            this.msg = 'รอสักครู่';
            this.status_loading = 1;
            this.showLoadingModal();
            this.$store.dispatch("RentalFee/search", this.search).then(() => {
                this.hideLoadingModal();
            })
        },
        showRentalFeeModal() {
            this.$refs.rental_fee.show();
        },
        hideRentalFeeModal() {
            this.$refs.rental_fee.hide();
        },
        showModalDelete(id) {
            this.$refs.delete_item.show();
            this.id = id;
        },
        hideModalDelete() {
            this.$refs.delete_item.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        createRentalFee() {
            this.$store.dispatch("RentalFee/clearFormData").then(() => {
                this.showRentalFeeModal();
            })
        },
        reportRentalFee() {
            this.$refs.rental_fee_excel.show();
        },
        hideRentalFeeExcel() {
            this.$refs.rental_fee_excel.hide();
        },
        getExcel() {
            let rental_id = '';
            if (this.search.rental_fee) {
                this.search.rental_fee.forEach((x, i) => {
                    if (i > 0) rental_id += ',' + x.id
                    else rental_id += x.id
                })
                this.search.rental_fee_id = this.search.rental_fee.id
            }
            if (this.search.date) {
                this.search.date_start = moment(this.search.date[0]).format("YYYY-MM")
                this.search.date_end = moment(this.search.date[1]).format("YYYY-MM");
            } else {
                this.search.date_start = ''
                this.search.date_end = '';
            }
            window.open(`${domain}/rental_fee_excel?rental_id=${rental_id}&date_start=${this.search.date_start}&date_end=${this.search.date_end}`)
        },
        saveRentalFee(submitData) {
            if (submitData == 0) {
                this.$store.dispatch("RentalFee/clearFormData");
            } else {
                this.msg = 'รอสักครู่';
                this.status_loading = 1;
                this.showLoadingModal();
                this.$store.dispatch("RentalFee/saveRentalFee", {
                    id: submitData.id,
                    data: submitData
                }).then(() => {
                    this.$store.dispatch("RentalFee/setRentalFee");
                    this.$store.dispatch("Employee/getEmployeeAll").then(res => {
                        this.employeeAll = res.filter(data => !data.rental_fee_id);
                    });
                    this.hideLoadingModal();
                });
                this.$store.dispatch("RentalFee/clearFormData");
            }
            this.hideRentalFeeModal();
        },
        editRentalFee(id) {
            this.msg = 'รอสักครู่';
            this.search.before_page = this.dataPaginate.current_page;
            this.status_loading = 1;
            this.showLoadingModal();
            this.$store.dispatch("RentalFee/showRentalFeeByID", id).then(() => {
                this.hideRentalFeeModal();
                this.$refs.rental_fee.show();
            })
        },
        deleteRentalFee() {
            this.$store.dispatch("RentalFee/delete", this.id).then(() => {
                this.hideModalDelete();
                this.$store.dispatch("RentalFee/setRentalFee");
            });
        },
        goToElectricityBill(rental_fee_id) {
            this.msg = 'กรุณารอสักครู่';
            this.search.before_page = this.dataPaginate.current_page;
            this.status_loading = 1;
            this.showLoadingModal();
            this.$store.dispatch("RentalFee/showRentalFeeByID", rental_fee_id).then(() => {
                this.$store.dispatch("ElectricityBill/setElectricityBill", {
                    rental_fee_id: rental_fee_id,
                    page: 1
                })
                this.$router.push({
                    name: "electricity-bill-list"
                })
            })
        }
    }
}
</script>

<style scoped>
.select {
    border: 0px
}
</style>
